import card1 from "../../Assets/images/card1.png";
import card11 from "../../Assets/images/cardimg1.png";
import card12 from "../../Assets/images/cardimg2.png";
import card13 from "../../Assets/images/cardimg3.png";
import card10 from "../../Assets/images/card22.png";
import card21 from "../../Assets/images/cardimg21.png";
import card22 from "../../Assets/images/cardimg22.png";
import card23 from "../../Assets/images/cardimg23.png";
import card100 from "../../Assets/images/card33.png";
import card31 from "../../Assets/images/cardimg31.png";
import card32 from "../../Assets/images/cardimg32.png";
import card33 from "../../Assets/images/cardimg33.png";
import user1 from "../../Assets/images/user1.png";

const cardArray = [
  {
    id: 1,
    mainImg: card1,
    img1: card11,
    img2: card12,
    img3: card13,
    authorImg: user1,
    authorName: "kaneeth Olison",
    item: 28,
  },
  {
    id: 2,
    mainImg: card10,
    img1: card21,
    img2: card22,
    img3: card23,
    authorImg: user1,
    authorName: "Willie Barton",
    item: 28,
  },
  {
    id: 3,
    mainImg: card100,
    img1: card33,
    img2: card31,
    img3: card32,
    authorImg: user1,
    authorName: "Cecilla Cornmier",
    item: 28,
  },
];

export default cardArray;
